var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1284_3834",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1284_3834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 108"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 84",
    x1: 5.6352,
    y1: 5.63604,
    x2: 18.3631,
    y2: 18.364,
    stroke: "#141414",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 85",
    x1: 18.3637,
    y1: 5.63593,
    x2: 5.63579,
    y2: 18.3639,
    stroke: "#141414",
    strokeWidth: 1.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXbutton);
export default __webpack_public_path__ + "static/media/Xbutton.4c8dc199eb21a5164d1b39cf541aceb4.svg";
export { ForwardRef as ReactComponent };